<template>
  <div class="activities-enroll create-fabu">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="enroll-view">
      <el-form-item label="问题名称" prop="title">
        <div class="form-item">
          <div class="right-ipt">
            <el-input
              v-model="ruleForm.title"
              placeholder="请输入问题名称"
              show-word-limit
              :maxlength="50"
            >
            </el-input>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="问题正文" prop="">
        <div class="form-item">
          <div class="right-ipt">
            富文本
          </div>
        </div>
      </el-form-item>
      <el-form-item label="悬赏" prop="">
        <div class="form-item">
          <div class="right-ipt ques-set-money">
            <el-input class="mon-ipt" v-model="ruleForm.setMon" disabled />
            <el-button type="danger" @click="setXSPriceEvent">设置金额</el-button>
            <div class="wanfa" @click="wanfaEvent">
              <span>?</span>玩法
            </div>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="标签" prop="">
        <div class="form-item">
          <div class="right-ipt">
            <el-button type="danger" @click="selectTagsShowEvent">选择标签</el-button>
            <div class="tag-list">
              <el-tag size="small" type="success" effect="dark" closable>标签一</el-tag>
              <el-tag size="small" type="success" effect="dark" closable>标签一</el-tag>
              <el-tag size="small" type="success" effect="dark" closable>标签一</el-tag>
              <el-tag size="small" type="success" effect="dark" closable>标签一</el-tag>
            </div>
          </div>
        </div>
      </el-form-item>
      
      <div class="last-btn">
        <el-button size="medium" type="primary"><i class="el-icon-finished"></i> 保存</el-button>
        <el-button size="medium" type="warning"><i class="el-icon-view"></i> 预览</el-button>
        <el-button size="medium" type="success"><i class="el-icon-s-promotion"></i> 发布问答</el-button>
      </div>
    </el-form>
    <!-- 设置悬赏金额弹窗 -->
    <el-dialog
      title="设置悬赏金额"
      center
      :visible.sync="xsPriceDia"
      :width="$store.state.app.device === 'desktop' ? '600px' : '90%'"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <div class="setting-items">
        <el-button class="item" type="danger">1 元</el-button>
        <el-button class="item">2 元</el-button>
        <el-button class="item">5 元</el-button>
        <el-button class="item">10 元</el-button>
        <el-button class="item">15 元</el-button>
        <el-button class="item">20 元</el-button>
        <el-input
          class="item-ipt"
          placeholder="手动输入"
          v-model="ruleForm.setMon"
          show-word-limit
          :maxlength="8"
        >
          <i slot="suffix" class="dan-wei">元</i>
        </el-input>
      </div>
      <span slot="footer" class="setting-items-footer">
        <el-button @click="xsPriceDia = false">取 消</el-button>
        <el-button type="danger" @click="setPrice">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 悬赏规则弹窗 -->
    <el-dialog
      title="悬赏规则"
      top="65px"
      :visible.sync="dialogWanfa"
      :width="$store.state.app.device === 'desktop' ? '600px' : '90%'"
      center
    >
      <wanfa />
    </el-dialog>
    <!-- 选择标签弹窗 -->
    <el-dialog
      title="选择标签"
      :visible.sync="dialogTags"
      :width="$store.state.app.device === 'desktop' ? '500px' : '90%'"
      top="50px"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
    >
      <div class="select-tags-cont">
        <el-button
          class="tag-btn"
          :type="item.active === false ? 'info' : 'danger'"
          v-for="(item, index) in tagList"
          :key="index"
          @click="selectTagsEvent(index)"
        >
          {{item.label}}
        </el-button>
      </div>
      <div style="margin-top: 15px;">
        <el-input placeholder="请输入新标签" v-model="newTagVal" maxlength="10" show-word-limit>
          <el-button slot="append">添加</el-button>
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="selectTagsOver">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import wanfa from '../../question/detail/wanfa'

export default {
  props: {},
  components: {
    wanfa
  },
  data () {
    return {
      xsPriceDia: false,
      dialogWanfa: false,
      dialogTags: false,
      tagList: [
        {id: 0, label: '标签一', active: false},
        {id: 1, label: '标签二', active: false},
        {id: 2, label: '标签三', active: false},
        {id: 3, label: '标签四', active: false},
        {id: 4, label: '标签五', active: false},
        {id: 5, label: '标签六', active: false},
        {id: 6, label: '标签七', active: false},
        {id: 7, label: '标签八', active: false},
        {id: 8, label: '标签九', active: false}
      ],
      newTagVal: '',
      ruleForm: {
        title: '',
        setMon: ''
      },
      rules: {
        title: [{required: true, message: '请输入文章名称', trigger: 'blur'}]
      }
    }
  },
  computed: {},
  mounted () {},
  methods: {
    setXSPriceEvent () {
      this.xsPriceDia = true
    },
    setPrice () {
      this.xsPriceDia = false
      this.ruleForm.setMon = 5
    },
    wanfaEvent () {
      this.dialogWanfa = true
    },
    selectTagsShowEvent () {
      this.dialogTags = true
    },
    selectTagsEvent (index) {
      this.tagList[index].active = !this.tagList[index].active
    },
    selectTagsOver () {
      this.dialogTags = false
    },
  }
}
</script>

<style scoped lang="less">
@import "../create.less";
</style>
